import { RVFlowBlockTypes } from "Components/elements/RVFlow/constants";
import { NodeType } from "Types/Journey";

/** Block container variants used by journey builder and Copilot preview. */
export type JourneyBlockVariant = (typeof RVFlowBlockTypes)[keyof typeof RVFlowBlockTypes];

type NodeTypeConfig = {
    title: string;
    variant: JourneyBlockVariant;
};

const DEFAULT_CONFIG: NodeTypeConfig = {
    title: "Node",
    variant: RVFlowBlockTypes.OtherAction,
};

const NODE_TYPE_CONFIG: Record<NodeType, NodeTypeConfig> = {
    [NodeType.Trigger]: { title: "Trigger", variant: RVFlowBlockTypes.Trigger },
    [NodeType.Delay]: { title: "Delay", variant: RVFlowBlockTypes.Timing },
    [NodeType.Call]: { title: "Call", variant: RVFlowBlockTypes.Agent },
    [NodeType.SMS]: { title: "SMS", variant: RVFlowBlockTypes.Automated },
    [NodeType.AgentSMSTask]: { title: "Agent SMS", variant: RVFlowBlockTypes.Agent },
    [NodeType.CancelTask]: { title: "Cancel Task", variant: RVFlowBlockTypes.OtherAction },
    [NodeType.CustomTask]: { title: "Custom Task", variant: RVFlowBlockTypes.Agent },
    [NodeType.Conditional]: { title: "Conditional Match", variant: RVFlowBlockTypes.Logic },
    [NodeType.ABTest]: { title: "A/B Test", variant: RVFlowBlockTypes.Logic },
    [NodeType.Webhook]: { title: "Webhook", variant: RVFlowBlockTypes.OtherAction },
    [NodeType.AssignTargetAgent]: { title: "Assign Target Agent", variant: RVFlowBlockTypes.OtherAction },
    [NodeType.UpdateTask]: { title: "Update Task", variant: RVFlowBlockTypes.OtherAction },
    [NodeType.Reminder]: { title: "Reminder", variant: RVFlowBlockTypes.OtherAction },
    [NodeType.ScheduledCallback]: { title: "Scheduled Callback", variant: RVFlowBlockTypes.OtherAction },
    [NodeType.UpdateContact]: { title: "Update Contact", variant: RVFlowBlockTypes.OtherAction },
    [NodeType.DecisionAI]: { title: "Decision AI", variant: RVFlowBlockTypes.AI },
    [NodeType.StickyNote]: { title: "Sticky Note", variant: RVFlowBlockTypes.OtherAction },
    [NodeType.DEMO_EightByEight]: { title: "8x8", variant: RVFlowBlockTypes.Integration },
    [NodeType.DEMO_RinglessVM]: { title: "Ringless VM", variant: RVFlowBlockTypes.Automated },
    [NodeType.DEMO_AgentlessCall]: { title: "Agentless Call", variant: RVFlowBlockTypes.Automated },
    [NodeType.DEMO_VoiceAI]: { title: "Voice AI", variant: RVFlowBlockTypes.AI },
    [NodeType.DEMO_Genesys]: { title: "Genesys", variant: RVFlowBlockTypes.Integration },
    [NodeType.DEMO_Talkdesk]: { title: "Talkdesk", variant: RVFlowBlockTypes.Integration },
    [NodeType.DEMO_NICE]: { title: "NICE", variant: RVFlowBlockTypes.Integration },
    [NodeType.DEMO_Five9]: { title: "Five9", variant: RVFlowBlockTypes.Integration },
    [NodeType.DEMO_SMSAI]: { title: "SMS AI", variant: RVFlowBlockTypes.AI },
    [NodeType.DEMO_CustomTaskAI]: { title: "Custom AI Task", variant: RVFlowBlockTypes.AI },
    [NodeType.DEMO_SendEmail]: { title: "Send Email", variant: RVFlowBlockTypes.Automated },
    [NodeType.DEMO_EmailTask]: { title: "Email Task", variant: RVFlowBlockTypes.Agent },
};

/** Resolve display title + BlockContainer variant for a journey node type. */
export function getJourneyNodeTypeConfig(nodeType: NodeType | undefined): NodeTypeConfig {
    if (!nodeType) {
        return DEFAULT_CONFIG;
    }
    return NODE_TYPE_CONFIG[nodeType];
}
